// extracted by mini-css-extract-plugin
module.exports = {"emptyCell":"StatementsCell_emptyCell__1yTKD","lessThanZero":"StatementsCell_lessThanZero__wCMWE","cell":"StatementsCell_cell__1N21v"};